import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import PsContext from "../../context";
import { printDocument, baseUrl } from "../../utils";

const PrintSalarySlip = (props) => {
  const context = useContext(PsContext);
  console.log(context);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState(props.dataSourceList);
  const [dataView, setDataView] = useState(props.dataSource);
  const [setupData, setSetupData] = useState(props.setupData);
  const [setupOutData, setSetupOutData] = useState(props.setupOutData);

  useEffect(() => {
    // printDocument("leave_list");
    //if (props.onSuccess) props.onSuccess();
  }, []);

  let rupee = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  });
  let incomeamt = 0;
  let deduction = 0;

  var imageURL = baseUrl + "public/app_fav.png";
  return (
    <>
      {/* <div style={{ display: "block" }}> */}
      <div style={{ display: "block" }}>
        <div id="leave_list">
          <Row className="mt-3">
            <Col md={12} className="mt-2">
              <Card>
                <Card.Body
                  className="slip"
                  style={{ overflowX: "auto", whiteSpace: "nowrap" }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }} />
                  <img
                    src={imageURL}
                    style={{
                      width: "65px",
                      height: "65px",
                      marginRight: "20px",
                    }}
                  />
                  <p
                    className="s1"
                    style={{
                      paddingTop: "3pt",
                      paddingLeft: "105pt",
                      textIndent: "0pt",
                      textAlign: "left",
                      fontSize: "13.5pt",
                      marginTop: "-70px",
                    }}
                  >
                    {context.settingValue("billheader_name")}
                  </p>
                  <p
                    style={{
                      paddingTop: "1pt",
                      paddingLeft: "115pt",
                      textIndent: "10pt",
                      textAlign: "left",
                      fontSize: "10.5pt",
                      marginTop: "-11px",
                    }}
                  >
                    {context.settingValue("billheader_addresslineone") && (
                      <>{context.settingValue("billheader_addresslineone")}</>
                    )}
                  </p>
                  <p
                    style={{
                      paddingLeft: "160pt",
                      textIndent: "10pt",
                      textAlign: "left",
                      fontSize: "10.5pt",
                      margin: "0pt",
                    }}
                  >
                    {context.settingValue("billheader_addresslinetwo") && (
                      <>{context.settingValue("billheader_addresslinetwo")}</>
                    )}
                  </p>

                  <h1
                    style={{
                      paddingTop: "8pt",
                      paddingLeft: "150pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    {/* Payslip for the month of {dataView[0].month} */}
                  </h1>

                  <table
                    style={{
                      borderCollapse: "collapse",
                      marginLeft: "6.27629pt",
                    }}
                    cellspacing="0"
                  >
                    <tr>
                      <td
                        style={{
                          width: "100pt",
                          borderTopStyle: "solid",
                          borderTopWidth: "1pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "7pt",
                            paddingLeft: "7pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          Name:
                        </p>
                      </td>
                      <td
                        style={{
                          width: "163pt",
                          borderTopStyle: "solid",
                          borderTopWidth: "1pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "7pt",
                            paddingLeft: "90pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          {dataView[0].emp_name}
                        </p>
                      </td>
                      <td
                        style={{
                          width: "140pt",
                          borderTopStyle: "solid",
                          borderTopWidth: "1pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "7pt",
                            paddingLeft: "7pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          Employee ID:
                        </p>
                      </td>
                      <td
                        style={{
                          width: "135pt",
                          borderTopStyle: "solid",
                          borderTopWidth: "1pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "7pt",
                            paddingLeft: "100pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          {dataView[0].emp_code}
                        </p>
                      </td>
                    </tr>
                    <tr style={{ height: "19pt" }}>
                      <td
                        style={{
                          width: "11pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "7pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          Designation:
                        </p>
                      </td>
                      <td
                        style={{
                          width: "163pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "90pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          {dataView[0].designation}
                        </p>
                      </td>
                      <td
                        style={{
                          width: "140pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "7pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          Bank Name:
                        </p>
                      </td>
                      <td
                        style={{
                          width: "135pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "90pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          {dataView[0].emp_bank_name}
                        </p>
                      </td>
                    </tr>
                    <tr style={{ height: "19pt" }}>
                      <td
                        style={{
                          width: "111pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "7pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          Department:
                        </p>
                      </td>
                      <td
                        style={{
                          width: "163pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "90pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          {dataView[0].department}
                        </p>
                      </td>
                      <td
                        style={{
                          width: "140pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "7pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          Bank Account Number:
                        </p>
                      </td>
                      <td
                        style={{
                          width: "135pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "90pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          {dataView[0].account_no}
                        </p>
                      </td>
                    </tr>
                    <tr style={{ height: "19pt" }}>
                      <td
                        style={{
                          width: "111pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "7pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          LOP:
                        </p>
                      </td>
                      <td
                        style={{
                          width: "163pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "90pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          {dataView[0].emp_loss_of_pay}
                        </p>
                      </td>
                      <td
                        style={{
                          width: "140pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "7pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          PAN:
                        </p>
                      </td>
                      <td
                        style={{
                          width: "135pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "90pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          {dataView[0].emp_pan}
                        </p>
                      </td>
                    </tr>
                    <tr style={{ height: "23pt" }}>
                      <td
                        style={{
                          width: "111pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "7pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        ></p>
                      </td>
                      <td
                        style={{
                          width: "163pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "41pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        ></p>
                      </td>
                      <td
                        style={{
                          width: "140pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                        }}
                      >
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                          <br />
                        </p>
                      </td>
                      <td
                        style={{
                          width: "135pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                          <br />
                        </p>
                      </td>
                    </tr>
                  </table>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                  <table
                    style={{
                      bordercollapse: "collapse",
                      marginLeft: "6.17629pt",
                    }}
                    cellspacing="0"
                  >
                    <tr style={{ height: "26pt" }}>
                      <td
                        style={{
                          width: "176pt",
                          borderTopStyle: "solid",
                          borderTopWidth: "1pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "7pt",
                            paddingLeft: "7pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          Earnings
                        </p>
                      </td>
                      <td
                        style={{
                          width: "98pt",
                          borderTopStyle: "solid",
                          borderTopWidth: "1pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "7pt",
                            paddingRight: "6pt",
                            textIndent: "0pt",
                            textAlign: "right",
                          }}
                        >
                          Amount
                        </p>
                      </td>
                      <td
                        style={{
                          width: "152pt",
                          borderTopStyle: "solid",
                          borderTopWidth: "1pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "7pt",
                            paddingLeft: "7pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          Deductions
                        </p>
                      </td>
                      <td
                        style={{
                          width: "123pt",
                          borderTopStyle: "solid",
                          borderTopWidth: "1pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "7pt",
                            paddingRight: "6pt",
                            textIndent: "0pt",
                            textAlign: "right",
                          }}
                        >
                          Amount
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        colSpan={2}
                        style={{
                          width: "176pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                          verticalAlign: "top",
                        }}
                      >
                        <table>
                          {setupData &&
                            setupData.length > 0 &&
                            setupData.map((item, i) => {
                              parseFloat(item.income_percentage) > 0 &&
                                (incomeamt +=
                                  (dataView[0].emp_basic_pay *
                                    parseFloat(item.income_percentage)) /
                                  100);

                              (item.income_percentage == "" ||
                                parseFloat(item.income_percentage) == 0) &&
                              item.income_amount
                                ? (incomeamt += parseFloat(item.income_amount))
                                : (incomeamt += 0);

                              return (
                                <tr style={{ height: "23pt" }}>
                                  <td>
                                    <p
                                      className="s2"
                                      style={{
                                        paddingTop: "3pt",
                                        paddingLeft: "7pt",
                                        textIndent: "0pt",
                                        textAlign: "left",
                                      }}
                                    >
                                      {item.income_type}
                                    </p>
                                  </td>
                                  <td
                                    style={{
                                      width: "98pt",
                                    }}
                                  >
                                    <p
                                      className="s2"
                                      style={{
                                        paddingTop: "3pt",
                                        paddingRight: "6pt",
                                        textIndent: "0pt",
                                        textAlign: "right",
                                      }}
                                    >
                                      {parseFloat(item.income_percentage) > 0 &&
                                        rupee.format(
                                          (dataView[0].emp_basic_pay *
                                            parseFloat(
                                              item.income_percentage
                                            )) /
                                            100
                                        )}
                                      {(item.income_percentage == "" ||
                                        parseFloat(item.income_percentage) ==
                                          0) &&
                                        rupee.format(item.income_amount)}
                                    </p>
                                  </td>
                                </tr>
                              );
                            })}
                        </table>
                      </td>
                      <td
                        colSpan={2}
                        style={{
                          width: "176pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                          verticalAlign: "top",
                        }}
                      >
                        {" "}
                        <table>
                          {setupOutData &&
                            setupOutData.length > 0 &&
                            setupOutData.map((item, i) => {
                              parseFloat(item.deduction_percentage) > 0 &&
                                (deduction +=
                                  (dataView[0].emp_basic_pay *
                                    parseFloat(item.deduction_percentage)) /
                                  100);

                              (item.deduction_percentage == "" ||
                                parseFloat(item.deduction_percentage) == 0) &&
                              item.deduction_amount
                                ? (deduction += parseFloat(
                                    item.deduction_amount
                                  ))
                                : (deduction += 0);

                              return (
                                <tr style={{ height: "23pt" }}>
                                  <td className="" style={{ width: "176pt" }}>
                                    <p
                                      className="s2 employeedetailsp1"
                                      style={{ paddingLeft: "7pt" }}
                                    >
                                      {item.deduction_type}
                                    </p>
                                  </td>
                                  <td
                                    style={{
                                      width: "98pt",
                                    }}
                                  >
                                    <p
                                      className="s2 employeedetailsp1r"
                                      style={{ paddingRight: "6pt" }}
                                    >
                                      {parseFloat(item.deduction_percentage) >
                                        0 &&
                                        rupee.format(
                                          (dataView[0].emp_basic_pay *
                                            parseFloat(
                                              item.deduction_percentage
                                            )) /
                                            100
                                        )}
                                      {(item.deduction_percentage == "" ||
                                        item.deduction_percentage == 0) &&
                                        rupee.format(item.deduction_amount)}
                                    </p>
                                  </td>
                                </tr>
                              );
                            })}
                        </table>
                      </td>
                    </tr>
                    <tr style={{ height: "03pt" }}>
                      <td
                        style={{
                          width: "176pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingLeft: "7pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        ></p>
                      </td>
                      <td
                        style={{
                          width: "98pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "3pt",
                            paddingRight: "6pt",
                            textIndent: "0pt",
                            textAlign: "right",
                          }}
                        ></p>
                      </td>
                      <td
                        style={{
                          width: "152pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                        }}
                      >
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                          <br />
                        </p>
                      </td>
                      <td
                        style={{
                          width: "123pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                          <br />
                        </p>
                      </td>
                    </tr>
                    <tr style={{ height: "26pt" }}>
                      <td
                        style={{
                          width: "176pt",
                          borderTopStyle: "solid",
                          borderTopWidth: "1pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "7pt",
                            paddingLeft: "7pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          Total Earnings
                        </p>
                      </td>
                      <td
                        style={{
                          width: "98pt",
                          borderTopStyle: "solid",
                          borderTopWidth: "1pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "7pt",
                            paddingRight: "6pt",
                            textIndent: "0pt",
                            textAlign: "right",
                          }}
                        >
                          {rupee.format(incomeamt)}
                        </p>
                      </td>
                      <td
                        style={{
                          width: "152pt",
                          borderTopStyle: "solid",
                          borderTopWidth: "1pt",
                          borderLeftStyle: "solid",
                          borderLeftWidth: "1pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "7pt",
                            paddingLeft: "7pt",
                            textIndent: "0pt",
                            textAlign: "left",
                          }}
                        >
                          Total Deductions
                        </p>
                      </td>
                      <td
                        style={{
                          width: "123pt",
                          borderTopStyle: "solid",
                          borderTopWidth: "1pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt",
                          borderRightStyle: "solid",
                          borderRightWidth: "1pt",
                        }}
                      >
                        <p
                          className="s2"
                          style={{
                            paddingTop: "7pt",
                            paddingRight: "6pt",
                            textIndent: "0pt",
                            textAlign: "right",
                          }}
                        >
                          {rupee.format(deduction)}
                        </p>
                      </td>
                    </tr>
                  </table>
                  <p
                    style={{
                      paddingTop: "11pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left",
                      fontSize: "10.5pt",
                    }}
                  >
                    Net Pay for the month:{" "}
                    <b>
                      {rupee.format(
                        parseFloat(incomeamt) - parseFloat(deduction)
                      )}
                    </b>
                  </p>
                  <p
                    style={{
                      paddingTop: "4pt",
                      paddingLeft: "135pt",
                      textIndent: "0pt",
                      textAlign: "center",
                      fontSize: "10.5pt",
                    }}
                  >
                    This is a system generated payslip and does not require
                    signature.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default PrintSalarySlip;
